import React, {useState} from 'react'
import {useMatchMedia} from 'utils/hooks/useMatchMedia'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import small_logo from 'assets/img/logo/logo-small.svg'
import {Show} from 'utils/ui/Show'
import {routes} from 'routes/routes'
import {LocalLink} from 'i18n/LocalLink'
import {LanguageSelector} from 'i18n/LanguageSelector'
import {useI18n} from 'i18n/I18nContext'
import {useOrganizationAuth} from 'organization/Auth/Providers/OrganizationAuthProvider'
import {useOrganziationTheme} from 'organization/theme/OrganizationThemeProvider'
import {ProfileLinks} from 'organization/theme/Header/ProfileLinks'
import {FirstSteps} from 'organization/theme/Header/FirstSteps'

export const Header = (props: {fullWidth?: boolean; eventHeader?: boolean}) => {
  const {user} = useOrganizationAuth()
  const {t} = useI18n()
  const isNarrowHeader = useMatchMedia('(max-width:767px)')

  const {SidebarHandle} = useOrganziationTheme()
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false)
  const handleToggleFullScreen = () => {
    if (!isFullScreen) {
      enterFullScreen()
    } else {
      exitFullScreen()
    }
  }

  const enterFullScreen = () => {
    const docElement = document.documentElement

    if (docElement.requestFullscreen) {
      docElement.requestFullscreen()
    } else if ((docElement as any).mozRequestFullScreen) {
      ;(docElement as any).mozRequestFullScreen()
    } else if ((docElement as any).webkitRequestFullscreen) {
      ;(docElement as any).webkitRequestFullscreen()
    }
    setIsFullScreen(true)
  }

  const exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if ((document as any).mozCancelFullScreen) {
      ;(document as any).mozCancelFullScreen()
    } else if ((document as any).webkitExitFullscreen) {
      ;(document as any).webkitExitFullscreen()
    }
    setIsFullScreen(false)
  }

  return (
    <div
      className="app__header__area"
      style={props?.fullWidth ? {width: '100%'} : {}}
    >
      <div className="app__header-inner">
        <div className="app__header-row-main">
          <div className="app__header-left">
            {props?.fullWidth && (
              <LocalLink to={routes.organization.list} style={{height: '50px'}}>
                <img
                  style={{width: '100%', height: '100%'}}
                  src={small_logo}
                  alt={t('logo.notFound')}
                />
              </LocalLink>
            )}

            {!props?.fullWidth && (
              <button onClick={SidebarHandle} id="sidebar__active">
                <div className="bar-icon-2">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </button>
            )}

            {props.eventHeader && <FirstSteps />}
          </div>
          <div className="app__header-right">
            <div className="app__header-action">
              <ul>
                <LanguageSelector compact={isNarrowHeader} />
                <li className="full-screen-button">
                  <button
                    type="button"
                    onClick={handleToggleFullScreen}
                    aria-label={t('header.fullScreenAria')}
                  >
                    <div className="nav-item">
                      <div className="notification__icon">
                        <FullscreenIcon />
                      </div>
                    </div>
                  </button>
                </li>
              </ul>
            </div>

            <Show if={user}>
              <ProfileLinks />
            </Show>
            <Show if={!user}>
              <div>
                <LocalLink to={routes.login} className="fill__btn">
                  {t('common.login')}{' '}
                  <i className="fa-regular fa-angle-right"></i>
                </LocalLink>
              </div>
            </Show>
          </div>
        </div>
      </div>
    </div>
  )
}
